import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../types';
import { AUTH_SLICE_NAME } from './sliceName';

const sliceState = (state: Pick<RootState, typeof AUTH_SLICE_NAME>): RootState[typeof AUTH_SLICE_NAME] =>
  state[AUTH_SLICE_NAME];

export const getPolicy = createSelector(sliceState, (state) => state.policy);
export const getB2cTokens = createSelector(sliceState, (state) => state.b2cTokens);
